/* tslint:disable:import-spacing */
/*
tslint:disable:typedef-whitespace
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}        from '@/util/i.command';
import {WorkBlock}   from '@/models/scenario/work.block';
import {DiversionEditor}  from './diversion.editor';

/**
 *
 * @class SetWorkCommand
 *
 * @brief reversible updates of the applicable work block
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetWorkCommand implements ICommand {

  private oldValue: WorkBlock;
  private newValue: WorkBlock;
  private editor:   DiversionEditor;

  constructor(oldValue: WorkBlock, newValue: WorkBlock, editor: DiversionEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setWork(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setWork(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    const a = (this.oldValue instanceof WorkBlock) ? this.oldValue.asString() : '';
    const b = (this.newValue instanceof WorkBlock) ? this.newValue.asString() : '';

    return '[work] ' + a + ' => ' + b;
  }

}
